exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/** Bootstrap navbar fix (https://git.io/fADqW) */\n.quantity[data-v-78c64488] {\n  display: flex;\n  align-items: center;\n}\n.quantity--sp[data-v-78c64488] {\n  justify-content: center;\n}\n.quantity__field[data-v-78c64488] {\n  width: 200px;\n  border-color: #b9b9b9;\n  border-radius: 0px;\n  flex: 0 0 auto;\n}\n.quantity__field--sp[data-v-78c64488] {\n  width: 50px;\n}\n.quantity__unit[data-v-78c64488] {\n  margin-left: 0.5em;\n}\n.quantity__unit--sp[data-v-78c64488] {\n  font-size: 1rem;\n}", ""]);

// exports
